var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { DatadogLogger } from './logger';
var DatadogService = /** @class */ (function () {
    function DatadogService() {
    }
    DatadogService.init = function (config) {
        if (['development', 'local', 'test'].includes(config.environment)) {
            return;
        }
        var defaultSessionSampleRate = 100;
        var defaultTraceSampleRate = 100;
        var configSessionSampleRate = Number(config.sessionSampleRate);
        var configTraceSampleRate = Number(config.traceSampleRate);
        var sessionSampleRate = Number.isNaN(configSessionSampleRate)
            ? defaultSessionSampleRate
            : configSessionSampleRate;
        var traceSampleRate = Number.isNaN(configTraceSampleRate) ? defaultTraceSampleRate : configTraceSampleRate;
        var mutualOptions = {
            clientToken: config.clientToken,
            service: config.service,
            env: config.environment,
            site: 'datadoghq.com',
            sessionSampleRate: sessionSampleRate,
            traceSampleRate: traceSampleRate,
        };
        datadogLogs.init(__assign(__assign({}, mutualOptions), { silentMultipleInit: true }));
        datadogRum.init(__assign(__assign({}, mutualOptions), { applicationId: config.appId, sessionReplaySampleRate: 0, allowedTracingUrls: [/https:\/\/.*\.api.*\.getsquire\.com/, /https:\/\/.*\.getsquire\.com/], trackResources: true, trackLongTasks: true, trackUserInteractions: true }));
        DatadogService.logger = new DatadogLogger();
    };
    DatadogService.getLogger = function () {
        return DatadogService.logger;
    };
    DatadogService.logger = null;
    return DatadogService;
}());
export { DatadogService };
